<mat-expansion-panel class="expansion-panel">
  <mat-expansion-panel-header>
    <mat-panel-title> {{ 'filters.filters' | translate }} </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    <div>
      <agr-form [formGroup]="formGroup">
        <div class="form-container">
          <div class="manure-category-container spacing--margin-right">
            <mat-label class="text--bold" style="display: block">
              {{ 'form.shared.manureCategoryLabel' | translate }}
            </mat-label>
            <mat-form-field class="manure-category-input">
              <mat-select
                formControlName="manureCategory"
                [placeholder]="'filters.label' | translate"
                data-test="select-manureCategory"
              >
                <mat-option [value]="undefined">{{ 'filters.label' | translate }}</mat-option>
                @for (category of manureCategories; track category) {
                  <mat-option [value]="category" data-test="manureCategory-item">
                    {{ 'manureCategories.' + category | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="manure-type-container spacing--margin-right">
            <mat-label class="text--bold" style="display: block">
              {{ 'filters.manureTypeLabel' | translate }}
            </mat-label>
            <mat-form-field class="manure-type-input">
              <input
                type="text"
                [placeholder]="'filters.label' | translate"
                matInput
                formControlName="manureType"
                [matAutocomplete]="manureTypeAutocomplete"
              />
              <mat-autocomplete
                #manureTypeAutocomplete="matAutocomplete"
                [displayWith]="displayManureType()"
              >
                @for (type of filteredManureTypes$ | async; track type) {
                  <mat-option [value]="type.value">
                    {{ type.stringValue }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div class="amount-container spacing--margin-right">
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.amountInTonsLabel' | translate
            }}</mat-label>
            <div class="input-container">
              <mat-form-field class="spacing--margin-right min-amount-input">
                <input
                  matInput
                  type="number"
                  min="35"
                  step="1"
                  formControlName="amountFrom"
                  placeholder="{{ 'filters.amount-label-by' | translate }}"
                />
                <span matSuffix class="form-field-suffix--text">ton</span>
              </mat-form-field>
              <mat-form-field class="max-amount-input">
                <input
                  matInput
                  type="number"
                  min="35"
                  step="1"
                  formControlName="amountTo"
                  placeholder="{{ 'filters.amount-label-to' | translate }}"
                />
                <span matSuffix class="form-field-suffix--text">ton</span>
              </mat-form-field>
            </div>
          </div>

          <div class="homogeneous-container">
            <mat-label class="text--bold" style="display: block">{{
              'form.shared.homogeneousLabel' | translate
            }}</mat-label>
            <mat-form-field class="homogeneous-input">
              <mat-select
                formControlName="isHomogeneous"
                [placeholder]="'filters.label' | translate"
              >
                <mat-option [value]="undefined">{{ 'filters.label' | translate }}</mat-option>
                <mat-option [value]="true">{{ 'homogeneity.homogeneous' | translate }}</mat-option>
                <mat-option [value]="false">{{
                  'homogeneity.notHomogenous' | translate
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="distance-container spacing--margin-right">
            <mat-label style="display: block" class="text--bold">{{
              'filters.maxDistanceLabel' | translate
            }}</mat-label>
            <mat-form-field class="distance-input">
              <mat-select formControlName="distance" [placeholder]="'filters.label' | translate">
                <mat-option [value]="undefined">{{ 'filters.label' | translate }}</mat-option>
                <mat-option value="lessThan30km">&lt; 30 km</mat-option>
                <mat-option value="lessThan50km">&lt; 50 km</mat-option>
                <mat-option value="lessThan100km">&lt; 100 km</mat-option>
                <mat-option value="lessThan150km">&lt; 150 km</mat-option>
                <mat-option value="moreThan150km">&gt; 150 km</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="period-container spacing--margin-right">
            <mat-label class="text--bold">{{
              'filters.deliveryPeriodLabel' | translate
            }}</mat-label>
            <div class="flex--row">
              <mat-form-field class="period-input spacing--margin-right">
                <mat-select
                  formControlName="desiredDeliveryPeriodFrom"
                  [placeholder]="'form.select.from' | translate"
                  data-test="select-deliveryFrom"
                >
                  <mat-option [value]="undefined">{{ 'form.select.from' | translate }}</mat-option>
                  @for (month of months; track month) {
                    <mat-option [value]="month" data-test="month-item">
                      {{ 'months.' + month | translate | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field class="period-input">
                <mat-select
                  formControlName="desiredDeliveryPeriodTo"
                  [placeholder]="'form.select.to' | translate"
                  data-test="select-deliveryTo"
                >
                  <mat-option [value]="undefined">{{ 'form.select.to' | translate }}</mat-option>
                  @for (month of months; track month) {
                    <mat-option [value]="month" data-test="month-item">
                      {{ 'months.' + month | translate | titlecase }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="spacing--margin-right button-container">
            <button
              mat-raised-button
              color="primary"
              (click)="resetFilters()"
              class="reset-button"
              [disabled]="!formGroup.touched"
            >
              {{ 'filters.deleteFilters' | translate }}
            </button>
          </div>
        </div>
      </agr-form>
    </div>
  </div>
</mat-expansion-panel>
